/**
 * Created by xuyq on 2021/1/8.
 */
import QueryContentList from './view/QueryContentList.vue'
import LikeList from './view/LikeList.vue'
import FileUploadList from '@/modules/management/view/FileUploadList.vue'
import SensitiveWordList from '@/modules/management/view/SensitiveWordList.vue'
import KvTemplatetList from '@/modules/management/view/KvTemplatetList.vue'
import CategoryList from '@/modules/management/view/CategoryList.vue'
import ReserveMeetingRoom from '@/modules/management/view/ReserveMeetingRoom.vue'
import FeedbackList from './view/FeedbackList.vue'
import SystemShutdownSetting from '@/modules/management/view/SystemShutdownSetting'
import {
  mdiAccountBoxMultipleOutline,
  mdiFileUploadOutline,
  mdiThumbsUpDown,
  mdiHeadQuestionOutline,
  mdiCaseSensitiveAlt,
  mdiFormatListBulletedType,
  mdiRoomService,
  mdiCommentQuote,
  mdiStopCircleOutline,
} from '@mdi/js'
// import store from './store'

export default () => {
  let menu =
    {
      path: '/',
      name: 'management',
      title: 'Chatbot管理端',
      icon: mdiAccountBoxMultipleOutline,
      meta: {
        layout: 'content',
      },
      children: [
        {
          title: '提问记录',
          name: '提问记录',
          path: 'query',
          icon: mdiHeadQuestionOutline,
          component: QueryContentList,
          meta: {
            layout: 'content',
          },
        },
        {
          title: '点赞记录',
          name: '点赞记录',
          path: 'like',
          icon: mdiThumbsUpDown,
          component: LikeList,
          meta: {
            layout: 'content',
          },
        },
        {
          title: '文件上传',
          name: '文件上传',
          path: 'file',
          icon: mdiFileUploadOutline,
          component: FileUploadList,
          meta: {
            layout: 'content',
          },
        },
        {
          title: '敏感词',
          name: '敏感词',
          path: 'sensitiveWord',
          icon: mdiCaseSensitiveAlt,
          component: SensitiveWordList,
          meta: {
            layout: 'content',
          },
        },
        {
          title: '问答模板',
          name: '问答模板',
          path: 'kv',
          icon: mdiCaseSensitiveAlt,
          component: KvTemplatetList,
          meta: {
            layout: 'content',
          },
        },
        {
          title: '类别',
          name: '类别',
          path: 'category',
          icon: mdiFormatListBulletedType,
          component: CategoryList,
          meta: {
            layout: 'content',
          },
        },
        {
          title: '预订会议室',
          name: '预订会议室',
          path: 'reservemeetingroom',
          icon: mdiRoomService,
          component: ReserveMeetingRoom,
          meta: {
            layout: 'content',
          },
        },
        {
          title: '用戶反饋',
          name: '用戶反饋',
          path: 'feedback',
          icon: mdiCommentQuote,
          component: FeedbackList,
          meta: {
            layout: 'content',
          },
        },
        {
          title: '系统停机设置',
          name: 'SystemShutdownSetting',
          path: 'systemdown',
          icon: mdiStopCircleOutline,
          component: SystemShutdownSetting,
          meta: {
            layout: 'content',
          },
        },
        {
          component: () => import('@/modules/management/view/UpdateApiHeader'),
          path: 'updateApiHeader',
          name: 'updateApiHeader',
          hidden: true,
          meta: {
            layout: 'blank',
          },
        },
      ],
    }
  return {
    menu,
    // store
  }
}
